$ = jQuery;

let body = document.querySelector("body");

stickyHeader();
mobileMenu();
toggleLangMenu();

if($('#calc').length) {
	CustomSelect();
}
if (body.classList.contains("home")) {
    TestimonialsSlider();
}

// COOKIES
function setCookie(key, value, expiry, path) {
	var expires = new Date();
	expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    if(!path || path == "") {
        path = '/';
    }
	document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path='+ path +';';
}
function getCookie(key) {
	var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
	return keyValue ? keyValue[2] : null;
}
function eraseCookie(key, path) {
	document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path='+ path +';';
}

document.addEventListener("DOMContentLoaded", function() {
    if(getCookie('country') == null) {
        setCookie('country', 'PH', 30)
    }
});

// SELECT COUNTRY
$('.country-choose').click(function(e) {
    e.preventDefault()
    eraseCookie('country', window.location.pathname);
	let countryCode = $(this).data('country-code'),
        links = document.querySelectorAll('a');
    [].forEach.call(links, function(link) {
        setCookie('country', countryCode, 30, link.pathname);
        setCookie('country', countryCode, 30, '/es'+link.pathname);
    });
    document.location.reload(true)
})

// HEADER
function stickyHeader() {
    const header = document.querySelector("#masthead");
    const scrollUp = "sticky";
    const scrollDown = "sticky-up";
    let lastScroll = 0;

    window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll <= 40) {
            header.classList.remove(scrollUp);
            header.classList.remove(scrollDown);
            return;
        }

        if (currentScroll > lastScroll && ! header.classList.contains(scrollDown)) { // down
            header.classList.remove(scrollUp);
            header.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && header.classList.contains(scrollDown)) { // up
            header.classList.remove(scrollDown);
            header.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
    });
}

function mobileMenu() {
    let el = document.querySelectorAll('.menu-toggle');
    for (let i = 0; i < el.length; i++) {
        el[i].addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('header').classList.toggle('active');
        });
    }
}

function toggleLangMenu() {
    let el = document.querySelectorAll('.menu-language-switcher');
    for (let i = 0; i < el.length; i++) {
        el[i].addEventListener("click", function (e) {
            if (window.innerWidth <= 1024) {
                if (this.classList.contains('active')) {
                    this.classList.remove('active');
                } else {
                    e.preventDefault();
                    this.classList.add('active');
                }
            }
        });
    }
}

// TESTIMONIALS
function TestimonialsSlider() {
	$('#testimonials-carousel').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: '<button class="prev d-flex justify-content-center align-items-center"><img src="/wp-content/themes/sankara/dist/img/chevron-left.svg" width="1" height="1" alt="prev"></button>',
		nextArrow: '<button class="next d-flex justify-content-center align-items-center"><img src="/wp-content/themes/sankara/dist/img/chevron-right.svg" width="1" height="1" alt="next"></button>',
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: true,
					dots: true
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}

// CALCULATOR
function CustomSelect() {
    $(".custom-select").each(function () {
        let classes = $(this).attr("class"),
		 	template = '<div class="' + classes + '">';
        template += '<span class="custom-select-trigger" data-value="">' + $(this).attr("placeholder") + '</span>';
        template += '<div class="custom-options">';
        $(this).find("option").each(function () {
            template += '<span class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
        });
        template += '</div></div>';

        $(this).wrap('<div class="custom-select-wrapper"></div>');
        $(this).hide();
        $(this).after(template);
    });
    $(".custom-option:first-of-type").hover(function () {
        $(this).parents(".custom-options").addClass("option-hover");
    }, function () {
        $(this).parents(".custom-options").removeClass("option-hover");
    });
    $(".custom-select-trigger").on("click", function () {
        $('html').one('click', function () {
            $(".custom-select").removeClass("opened");
        });
        $(this).parents(".custom-select").toggleClass("opened");
        event.stopPropagation();
    });
    $(".custom-option").on("click", function () {
		let val = $(this).data("value");
        $(this).parents(".custom-select-wrapper").find("select").val(val);
        $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
        $(this).addClass("selection");
        $(this).parents(".custom-select").removeClass("opened");
        $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
		$(this).parents(".custom-select").find(".custom-select-trigger").attr('data-value', val);
    });
}
function ClearCalc() {
	$('#calc .transfer-header .clear').click(function(e) {
		e.preventDefault();
	})
	$('#calc .connvert-header .clear').click(function(e) {
		e.preventDefault();
	})
}
